import { APIClient } from "./api_helper";
import axios from "axios";

import * as url from "./url_helper";

const api = new APIClient();

export const postEventSongsList = (eventId, payload) => api.create(url.POST_VIEW_EVENT_SONGS(eventId), payload);
export const postEventSongsListHost = (eventId) => api.create(url.POST_VIEW_EVENT_SONGS_HOST(eventId), undefined);
export const patchEventUpdate = (id, payload) => api.update(url.PATCH_EVENT_UPDATE(id), payload);
export const patchEventStart = (id, payload) => api.update(url.PATCH_EVENT_START(id), payload);
export const patchEventEnd = (id, payload) => api.update(url.PATCH_EVENT_END(id), payload);
export const postEventSongAddAdmin = (payload) => api.create(url.POST_ADD_EVENT_SONG_ADMIN, payload);
export const getEventDetails = (id) => api.get(url.GET_VIEW_EVENT_DETAILS(id));
export const postEventSongAddGuest = (payload) => api.create(url.POST_ADD_EVENT_SONG_GUEST, payload);
export const deleteEventSongAdmin = (id) => api.delete(url.DELETE_EVENT_SONG_ADMIN(id));
export const deleteEventSongGuest = (id, payload) => api.create(url.DELETE_EVENT_SONG_GUEST(id), payload);
export const postEventSongNoteGuest = (id, payload) => api.create(url.POST_EVENT_SONG_NOTE_GUEST(id), payload);
export const postEventSongEditGuest = (id, payload) => api.create(url.POST_EVENT_SONG_EDIT_GUEST(id), payload);
export const postDedicationGuest = (payload) => api.create(url.POST_DEDICATION_GUEST, payload);
export const deleteDedicationGuest = (id, payload) => api.create(url.POST_DELETE_DEDICATION_GUEST(id), payload);
export const deleteDedicationAdmin = (id) => api.delete(url.DELETE_DEDICATION_ADMIN(id));

export const reorderEventSongs = (eventId, songIds) => api.create(`/event_song/${eventId}/reorder`, { songIds });

export const postEventLogoUpload = (id, formData) => {
  return axios.post(url.POST_EVENT_LOGO_UPLOAD(id), formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

